export default {"src":"/_next/static/media/header-socials-ig.10e39183.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};